/*
 *
 * Merchant Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 25-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@Merchant/set_item_to_show_detail',
	DO_RESET_ERROR: '@@Merchant/reset_error',
	// @generator action:route:type
	...createRequestTypes('@@Merchant', 'FETCH_MERCHANT_DETAIL'),
	...createRequestTypes('@@Merchant', 'DOWNLOAD_MERCHANT_REPORT'),
	...createRequestTypes('@@Merchant', 'REPORT_PROGRESS'),
	...createRequestTypes('@@Merchant', 'GENERATE_MERCHANT_REPORT_STATUS'),
	...createRequestTypes('@@Merchant', 'DELETE_MERCHANT'),
	...createRequestTypes('@@Merchant', 'CREATE_MERCHANT'),
	...createRequestTypes('@@Merchant', 'UPDATE_MERCHANT'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name fetchMerchantDetail
 * @return {object} - The action object
 */
export const fetchMerchantDetail = new MakeRequest('Merchant', 'fetch_merchant_detail');

/** @action request
 * * Insert a description
 * @name downloadMerchantReport
 * @return {object} - The action object
 */
export const downloadMerchantReport = new MakeRequest('Merchant', 'download_merchant_report');

/** @action request
 * * Insert a description
 * @name generateMerchantReportStatus
 * @return {object} - The action object
 */
export const generateMerchantReportStatus = new MakeRequest('Merchant', 'generate_merchant_report_status');

/** @action request
 * * Insert a description
 * @name reportProgress
 * @return {object} - The action object
 */
export const reportProgress = new MakeRequest('Merchant', 'report_progress');

/** @action request
 * * Insert a description
 * @name deleteMerchant
 * @return {object} - The action object
 */
export const deleteMerchant = new MakeRequest('Merchant', 'delete_merchant');

/** @action request
 * * Insert a description
 * @name createMerchant
 * @return {object} - The action object
 */
export const createMerchant = new MakeRequest('Merchant', 'create_merchant');

/** @action request
 * * Insert a description
 * @name updateMerchant
 * @return {object} - The action object
 */
export const updateMerchant = new MakeRequest('Merchant', 'update_merchant');

// @generator action:route:request

/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });

/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });

// @generator action:route
